<template>
  <VDetailBox :headline="$tc('common.bundle_information_sub_headline', index + 1)">
    <template #default>
      <VDescriptionList>
        <VEntryBadge
          name="common.bundle_result_label"
          :badge="instance.returnCode === '0' ? 'common.bundle_return_code_ok' : $tc('common.bundle_return_code_error', instance.returnCode)"
          :class="{ 'badge-negative': instance.returnCode !== '0' }"
        />
        <VEntry name="common.bundle_reason_return_code_label">
          <span v-html="$tf('common.bundle_reason_return_code_' + instance.returnCode, () => $t('common.bundle_reason_return_code_undefined'))"></span>
        </VEntry>
        <VEntryDate name="common.bundle_setup_date_label" :value="instance.setupDate" />
        <template v-if="isExpanded">
          <VEntry name="common.bundle_type_label" :value="$t('common.bundle_type_' + instance.bundleType)" />
          <VEntry name="common.bundle_template_id_label" :value="instance.bundleTemplateId" />
        </template>
      </VDescriptionList>

      <button class="btn btn-small btn-white h-ctr offset-top-1" :class="{ 'sr-only': isExpanded }" @click="isExpanded = true">
        {{ $t('common.bundle_button_more') }}
      </button>
    </template>

    <template v-if="isExpanded && instance.detailInfos && instance.detailInfos.length" #grayed>
      <VDescriptionList>
        <VEntry name="common.bundle_request_name_label">
          <select v-if="instance.detailInfos.length > 1" v-model="selectedRequest" class="form-select">
            <option v-for="(detail, index2) in instance.detailInfos" :key="'request_' + index2" :value="index2">{{ detail.requestName }}</option>
          </select>
          <span v-else>{{ instance.detailInfos[selectedRequest].requestName }}</span>
        </VEntry>
        <VEntry
          v-if="$te('common.bundle_request_description_' + instance.detailInfos[selectedRequest].requestName)"
          name="common.bundle_request_description_label"
        >
          <span v-html="$t('common.bundle_request_description_' + instance.detailInfos[selectedRequest].requestName)"></span>
        </VEntry>
        <VEntry name="common.bundle_request_result_label" :data="instance" :field="'detailInfos[' + selectedRequest + '].requestResult'" />
        <VEntryDate name="common.bundle_request_timestamp_label" :data="instance" :field="'detailInfos[' + selectedRequest + '].provisioningTime'" />
      </VDescriptionList>
    </template>
  </VDetailBox>
</template>

<script>
import VDescriptionList from '@/components/DescriptionList';
import VEntry from '@/components/DescriptionList/Entry';
import VEntryBadge from '@/components/DescriptionList/EntryBadge';
import VEntryDate from '@/components/DescriptionList/EntryDate';

export default {
  name: 'BundleInstance',

  components: {
    VDescriptionList,
    VEntry,
    VEntryBadge,
    VEntryDate,
    VDetailBox: () => import('@/components/UI/DetailBox'),
  },

  props: {
    instance: {
      type: Object,
      required: true,
    },

    index: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isExpanded: false,
      selectedRequest: 0,
    };
  },
};
</script>
